import ImageIcon from '@mui/icons-material/ImageOutlined';
import { Box, Tooltip } from '@mui/material';
import { useState } from 'react';

const THUMB = 40;

/**
 * First photo of the asset, left of its code in a list (Assets page, a place's Assets tab; urls from
 * `useFirstPhotoUrls`); hover shows it larger. No photo: a muted placeholder keeps the column even.
 */
export function AssetThumb({ url }: { url: string | undefined }) {
  // a signed link whose file is gone (or will not load) falls back to the placeholder, not a broken image
  const [failed, setFailed] = useState<string | null>(null);
  const box = {
    width: THUMB,
    height: THUMB,
    flexShrink: 0,
    borderRadius: 1,
    bgcolor: 'action.hover',
    display: 'grid',
    placeItems: 'center',
    overflow: 'hidden',
  } as const;
  if (!url || failed === url)
    return (
      <Box sx={box} data-testid="asset-thumb-empty">
        <ImageIcon fontSize="small" sx={{ color: 'text.disabled' }} />
      </Box>
    );
  return (
    <Tooltip
      placement="right"
      enterDelay={300}
      slotProps={{ tooltip: { sx: { p: 0.5, bgcolor: 'background.paper', boxShadow: 3 } } }}
      title={
        <Box
          component="img"
          src={url}
          alt=""
          sx={{ display: 'block', width: 200, height: 200, objectFit: 'cover', borderRadius: 1 }}
        />
      }
    >
      <Box sx={box}>
        <Box
          component="img"
          src={url}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setFailed(url)}
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>
    </Tooltip>
  );
}
